import { toast } from 'react-toastify';

export const showErrorToast = (error, defaultMessage = 'An unknown error occurred') => {
  const errorMessage = error.response?.data?.message || error.message || defaultMessage;
  toast.error(`Error: ${errorMessage}`);
};